/**
 * 门诊开方剂型码与后端药品分类码的映射。
 *
 * 两者语义不同，不可混用：
 * - 前端剂型码（页面上「颗粒/饮片/膏方/水丸」单选框的值）：0 颗粒、1 饮片、2 膏方、3 水丸。
 * - 后端药品分类 TcMedicine.meType：0 颗粒、1 饮片、2 辅药。
 *
 * 接口 /buz/medicine/transMeType 的 meType 参数取的是「药品分类」，服务端只放行 0 和 1
 * （见 TcMedicineController#transMeType），因此膏方、水丸必须按「沿用饮片药材」映射为 1，
 * 直接把剂型码 2/3 发出去会被服务端以「参数错误」拒绝，导致转换失败并回滚。
 */

/**
 * 目标剂型码 → 转换接口的 meType（后端药品分类码）。
 * 膏方、水丸沿用饮片药材，统一映射为 1；颗粒为 0。
 *
 * @param {string|number} targetMedicineType 目标剂型码（0 颗粒、1 饮片、2 膏方、3 水丸）
 * @returns {string} 接口 meType：'0' 颗粒、'1' 饮片
 */
export function getMedicineConversionTargetType(targetMedicineType) {
    return `${targetMedicineType}` === '0' ? '0' : '1';
}
